import { Directive, TemplateRef, ViewContainerRef, Input, OnInit, ElementRef } from '@angular/core';
import { userOrgModel } from '../models';
import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';

@Directive({
  selector: '[appOrganisationRole]'
})
export class OrganisationRoleDirective implements OnInit {
  @Input('role') role: string;
  @Input('orgId') orgId: string;
  @Input('userRole') userRole :userOrgModel;
  isRendered = false;
    show = false;

  constructor(private el: ElementRef,
    private auth: AuthService) {

  }

//   @Input() set appOrganisationRole(r: string) {
//     this.role = r;
//   }
//   @Input() set appOrganisationRoleOrg(o: string) {
//     this.orgId = o;
//   }

private get roleField(){
    return `permission${this.role}`;   
}

  ngOnInit() {
    // console.log(`orgRoleDirective: ${this.role}, ${this.orgId}`);
    // console.log(this.userRole);

    if(this.userRole){
        this.doesRoleHavePermission();
    }else{
        if(this.orgId){
            this.auth.getUserOrganisation(this.orgId).subscribe(uOrg => {
                this.userRole = uOrg;
                this.doesRoleHavePermission();
            });  
        }
    }      
  }

  doesRoleHavePermission(){
      //console.log(`orgRoleDirective doesRoleHavePermission firing`);
      const ruleField = this.roleField;
        const val = this.userRole[ruleField];
        if(val){
            this.show = true;
        }else{
            this.show = false;
        }

        if(this.show){
            
        }else{
            this.el.nativeElement.style.display = 'none';
        }
  }
}
